import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NotifyService } from './notify.service';
import { AppComponent } from '../app.component';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  getMenuOrder() {
    throw new Error('Method not implemented.');
  }
  token;
  constructor(
    private http: HttpClient,
    private notifyService: NotifyService,
    private appCom: AppComponent
  ) {}
  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob',
    });
  }
  method(url, data, method): Observable<any> {
    this.token = sessionStorage.getItem('jwttoken');
    if (method === 'login') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      return this.http.post<any>(url, data, httpOptions).pipe(
        map((response: Response) => response, {
          response: data,
        }),
        catchError((error: any) => {
          if (error.status === 500) {
            this.notifyService.notifyError(
              error?.error?.errorResponseDTO?.errorMessage
            );
            return Observable.throw(new Error(error.message));
          } else if (error.status === 400) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 409) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 406) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 403) {
            this.appCom.logoutPopup();
          }
        })
      );
    }
    if (method === 'post') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          token: this.token,
        }),
      };
      return this.http.post<any>(url, data, httpOptions).pipe(
        map((response: Response) => response, {
          response: data,
        }),
        catchError((error: any) => {
          if (error.status === 500) {
            this.notifyService.notifyError(
              error?.error?.errorResponseDTO?.errorMessage
            );
            return Observable.throw(new Error(error.message));
          } else if (error.status === 400) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 409) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 406) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 403) {
            this.appCom.logoutPopup();
          }
        })
      );
    }
    if (method === 'get') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          token: this.token,
        }),
      };
      return this.http
        .get<any>(url, httpOptions)

        .pipe(
          map((response: Response) => response, {
            response: data,
          }),
          catchError((error: any) => {
            // this.notifyService.notifyError("Somthing went wrong ! Please try again later")
            if (error.status === 500) {
              this.notifyService.notifyError(
                error?.error?.errorResponseDTO?.errorMessage
              );
              return Observable.throw(new Error(error.message));
            } else if (error.status === 400) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 409) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 406) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 403) {
              this.appCom.logoutPopup();
            }
          })
        );
    }
    if (method === 'delete') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          token: this.token,
        }),
      };
      return this.http
        .delete<any>(url, httpOptions)

        .pipe(
          map((response: Response) => response, {
            response: data,
          }),
          catchError((error: any) => {
            if (error.status === 500) {
              this.notifyService.notifyError(
                error?.error?.errorResponseDTO?.errorMessage
              );
              return Observable.throw(new Error(error.message));
            } else if (error.status === 400) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 409) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 406) {
              return Observable.throw(new Error(error.message));
            } else if (error.status === 403) {
              this.appCom.logoutPopup();
            }
          })
        );
    }
    if (method === 'postunauth') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      return this.http.post<any>(url, data, httpOptions).pipe(
        map((response: Response) => response, {
          response: data,
        }),
        catchError((error: any) => {
          if (error.status === 500) {
            this.notifyService.notifyError(
              error?.error?.errorResponseDTO?.errorMessage
            );
            return Observable.throw(new Error(error.message));
          } else if (error.status === 400) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 409) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 406) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 403) {
            this.appCom.logoutPopup();
          }
        })
      );
    }
    if (method === 'getunauth') {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
      return this.http.get<any>(url, httpOptions).pipe(
        map((response: Response) => response, {
          response: data,
        }),
        catchError((error: any) => {
          if (error.status === 500) {
            this.notifyService.notifyError(
              error?.error?.errorResponseDTO?.errorMessage
            );
            return Observable.throw(new Error(error.message));
          } else if (error.status === 400) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 409) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 406) {
            return Observable.throw(new Error(error.message));
          } else if (error.status === 403) {
            this.appCom.logoutPopup();
          }
        })
      );
    }
    if (method === 'download') {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/octet-stream')
        .set('token', this.token);
      return this.http
        .get(url, { responseType: 'blob', headers: headers })
        .pipe(
          map((res: any) => res),
          catchError((error: any) => {
            if (error.status === 500) {
              this.notifyService.notifyError(
                error?.error?.errorResponseDTO?.errorMessage
              );
              return Observable.throw(new Error(error.status));
            } else if (error.status === 400) {
              return Observable.throw(new Error(error.status));
            } else if (error.status === 409) {
              return Observable.throw(new Error(error.status));
            } else if (error.status === 406) {
              return Observable.throw(new Error(error.status));
            } else if (error.status === 403) {
              this.appCom.logoutPopup();
            }
          })
        );
    }
  }
}
